import { BehaviorSubject } from "rxjs";
import queryString from "query-string";
import produce from "immer";

import { fetchWrapper } from "data/FetchWrapper";
// import { history } from 'data/History';
import { searchService } from "services";
import { ResponseType, StatusType } from "data/Types";

const { mapper } = searchService;
const web$ = new BehaviorSubject({});
const similar$ = new BehaviorSubject({});
const abort$ = new BehaviorSubject(new AbortController());
const baseUrl = `/api/search`;

const PAGE_SIZE = 20;
const MAX_PAGE = 100;

const mapWeb = (response) => {
  const result = {
    status: StatusType.Queried | StatusType.Result,
    resultset: [],
  };
  if (
    response.wikipedia &&
    response.wikipedia.query &&
    response.wikipedia.query.pages
  ) {
    Object.keys(response.wikipedia.query.pages).map((pageId) => {
      const page = response.wikipedia.query.pages[pageId];
      return result.resultset.push({
        id: pageId,
        responseType: ResponseType.WIKI,
        title: page.title,
        abstract: page.extract,
        url: [response.wikipedia.url],
      });
    });
  }
  if (response.google) {
    response.google.map((item) => {
      const qs = queryString.parse(
        item.image.thumbnailLink.substr(item.image.thumbnailLink.indexOf("?"))
      );
      return result.resultset.push({
        id: qs["q"].replace("tbn:", ""),
        responseType: ResponseType.GOOGLE,
        title: item.title,
        abstract: item.displayLink,
        image: item.image.thumbnailLink,
        url: [item.image.contextLink],
      });
    });
  }
  result.docsCount = result.resultset.length;
  return result;
};

const abort = () => {
  abort$.value.abort();
  abort$.next(new AbortController());
};

const web = (query) => {
  const result = { docsCount: 0, status: StatusType.Queried, resultset: null };
  web$.next(result);
  return fetchWrapper
    .get(`${baseUrl}/web/?query=${query}`, abort$.value.signal)
    .then((response) => web$.next(mapWeb(response)));
};

const similar = (responseId, page = 1, append = false) => {
  const result = produce(
    append
      ? similar$.value
      : { docsCount: 0, status: StatusType.Queried, resultset: null },
    (result) => {
      if (append) {
        result.status |= StatusType.Append;
      } else {
        result.status &= ~StatusType.Append;
      }
    }
  );
  similar$.next(result);
  return fetchWrapper
    .post(
      `${baseUrl}/similar/${responseId}?page=${page}`,
      undefined,
      abort$.value.signal
    )
    .then((response) => {
      const _result = produce(mapper.result(response), (_result) => {
        if (_result.docsCount > MAX_PAGE * PAGE_SIZE) {
          _result.docsCount = MAX_PAGE * PAGE_SIZE;
        }
        const index = page * PAGE_SIZE - PAGE_SIZE;
        const resultset = _result.resultset;
        if (append && result && result.resultset) {
          _result.resultset = [...result.resultset];
        } else {
          _result.resultset = new Array(_result.docsCount);
        }
        _result.resultset.splice(index, resultset.length, ...resultset);
        _result.status |= StatusType.Result;
      });
      similar$.next(_result);
      return _result;
    });
};

export const detailService = {
  web,
  similar,
  web$,
  similar$,
  get similarValue() {
    return similar$.value;
  },
  get webValue() {
    return web$.value;
  },
  abort,
  mapper: {
    ...mapper,
    web: mapWeb,
  },
};
